// GEMINI AI generated code to convert numbers into words
// takes a number in the form of an integer or string and returns the number as written words
export const convertNumberToWords = (n) => {
  if (n < 0) return false;
  if (n === 0) return "Zero";

  const singleDigit = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const doubleDigit = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const belowHundred = [
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const translate = (num) => {
    let word = "";
    if (num < 10) {
      word = singleDigit[num] + " ";
    } else if (num < 20) {
      word = doubleDigit[num - 10] + " ";
    } else if (num < 100) {
      let remainder = translate(num % 10);
      word = `${
        belowHundred[Math.trunc((num - (num % 10)) / 10) - 2]
      } ${remainder}`; // Using template literal
    } else if (num < 1000) {
      word = `${singleDigit[Math.trunc(num / 100)]} Hundred ${translate(
        num % 100
      )}`; // Using template literal
    } else if (num < 1000000) {
      word = `${translate(parseInt(num / 1000)).trim()} Thousand ${translate(
        num % 1000
      )}`; // Using template literal
    } else if (num < 1000000000) {
      word = `${translate(parseInt(num / 1000000)).trim()} Million ${translate(
        num % 1000000
      )}`; // Using template literal
    } else {
      word = `${translate(
        parseInt(num / 1000000000)
      ).trim()} Billion ${translate(num % 1000000000)}`; // Using template literal
    }
    return word;
  };

  let result = translate(n);
  return result.trim();
};

// laws by state
export const lawsByState = [
  {
    state: "AL",
    gracePeriod: null,
    securityDeposit: "21 days (Cal. Civ. Code § 1950.5)",
    vacate: {
      monthly: "30 days",
      yearly: "30 days",
    },
  },
  {
    state: "AK",
    gracePeriod: null,
    securityDeposit:
      "14 days if the Tenant gives proper notice to terminate tenancy; 30 days if the Tenant doesn't give proper notice or if the Landlord has deducted amounts needed to remedy damage caused by Tenant's failure to maintain the property (Alaska Stat. §§ 34.03.070, 34.03.120).",
    vacate: {
      monthly: "30 days",
      yearly: "30 days",
    },
  },
  {
    state: "AZ",
    gracePeriod: null,
    securityDeposit:
      "14 days (excluding Saturdays, Sundays, and legal holidays); Tenant has the right to be present at final inspection (Ariz. Rev. Stat. § 33-1321).",
    vacate: {
      monthly: "10 days (Arizona Revised Statute § 33-341)",
      yearly: "30 days",
    },
  },
  {
    state: "AR",
    gracePeriod: null,
    securityDeposit: "60 days (Ark. Code § 18-16-305).",
    vacate: {
      monthly: "30-days (Arkansas Code § 18-17-704)",
      yearly: "30-days (Arkansas Code § 18-17-704)",
    },
  },
  {
    state: "CA",
    gracePeriod: null,
    securityDeposit: "21 days (Cal. Civ. Code § 1950.5)",
    vacate: {
      monthly: "30-days (California Civil Code § 1946)",
      yearly: "30-days (California Civil Code § 1946)",
    },
  },
  {
    state: "CO",
    gracePeriod: null,
    securityDeposit:
      "one month, unless lease agreement specifies longer period of time (which can't be longer than 60 days); 72 hours (not counting weekends or holidays) if a hazardous condition involving gas equipment requires Tenant to vacate (Colo. Rev. Stat. §§ 38-12-103, 38-12-104).",
    vacate: {
      monthly:
        "21-days if stay was less than 6-months, otherwise 28-days (Colorado Revised Statute §13-40-107)",
      yearly: "91-days (Colorado Revised Statute §13-40-107)",
    },
  },
  {
    state: "CT",
    gracePeriod: 9,
    securityDeposit:
      "21 days, or within 15 days of receiving Tenant's forwarding address, whichever is later (Conn. Gen. Stat. § 47a-21).",
    vacate: {
      monthly: "30-days",
      yearly: "30-days",
    },
  },
  {
    state: "DE",
    gracePeriod: 5,
    securityDeposit: "20 days (Del. Code tit. 25, § 5514).",
    vacate: {
      monthly:
        "60-days from first day of next month after notice (Delaware Code Title 25 § 5106)",
      yearly: "60-days (Delaware Code Title 25 § 5106)",
    },
  },
  {
    state: "DC",
    gracePeriod: null,
    securityDeposit: "45 days (14 D.C. Mun. Regs. 309).",
    vacate: {
      monthly: "30-days",
      yearly: "30-days",
    },
  },
  {
    state: "FL",
    gracePeriod: null,
    securityDeposit:
      "15 to 60 days; depending on whether Tenant disputes deductions (Fla. Stat. § 83.49).",
    vacate: {
      monthly: "15-days (Florida Statute Title VI § 83.57)",
      yearly: "60-days (Florida Statute Title VI § 83.57)",
    },
  },
  {
    state: "GA",
    gracePeriod: null,
    securityDeposit: "30 days (Ga. Code § 44-7-34).",
    vacate: {
      monthly: "60-days (O.C.G.A Title 44 § 44-7-6 to 44-7-7)",
      yearly: "30-days (O.C.G.A Title 44 § 44-7-6 to 44-7-7)",
    },
  },
  {
    state: "HI",
    gracePeriod: null,
    securityDeposit: "14 days (Haw. Rev. Stat. § 521-44).",
    vacate: {
      monthly:
        "Landlord shall provide 45-days, Tenant shall provide 28-days (Hawaii Revised Statute § 521-71)",
      yearly: "N/A - lease defaults to month-to-month at end of term",
    },
  },
  {
    state: "ID",
    gracePeriod: null,
    securityDeposit:
      "21 days, or up to 30 days if Landlord and Tenant agree (Idaho Code § 6-321).",
    vacate: {
      monthly: "30-days (Idaho Statute § 55-208)",
      yearly: "30-days (Idaho Statute § 55-208)",
    },
  },
  {
    state: "IL",
    gracePeriod: 5,
    securityDeposit:
      "30 days after the Tenant has vacated or when the Tenant's right to possession ended, whichever is later. If Landlord doesn't return the deposit in full but fails to provide an itemized damage statement with repair costs and receipts, Landlord must return the full deposit within 45 days of Tenant's vacating the rental (765 Ill. Comp. Stat. § 710/1).",
    vacate: {
      monthly: "30-days (ILCS 735 5/9-207)",
      yearly: "30-days (ILCS 735 5/9-207)",
    },
  },
  {
    state: "IN",
    gracePeriod: null,
    securityDeposit: "45 days (Ind. Code §§ 32-31-3-12, 32-31-3-14).",
    vacate: {
      monthly: "30-days (IC § 32-31-5-4)",
      yearly: "30-days (IC § 32-31-5-4)",
    },
  },
  {
    state: "IA",
    gracePeriod: null,
    securityDeposit: "30 days (Iowa Code § 562A.12).",
    vacate: {
      monthly: "30-days (Iowa Code 562A.34)",
      yearly: "30-days (Iowa Code 562A.34)",
    },
  },
  {
    state: "KS",
    gracePeriod: null,
    securityDeposit:
      "14 days after the determination of the amount of any deductions, but in no event longer than 30 days after the end of the tenancy (Kan. Stat. § 58-2550).",
    vacate: {
      monthly: "30-days (Kansas Statute § 58-2570)",
      yearly: "30-days (Kansas Statute § 58-2570)",
    },
  },
  {
    state: "KY",
    gracePeriod: null,
    securityDeposit:
      "30 to 60 days; depends on whether Tenant disputes deductions (Ky. Rev. Stat. § 383.580).",
    vacate: {
      monthly: "30-days (Kentucky Statute § 383.695)",
      yearly: "30-days (Kentucky Statute § 383.695)",
    },
  },
  {
    state: "LA",
    gracePeriod: null,
    securityDeposit: "1 month (La. Rev. Stat. 9:3251.",
    vacate: {
      monthly:
        "10-days or 30-days if lease term is longer than 1-month (Louisiana Civil Code 2728)",
      yearly: "30-days (Louisiana Civil Code 2728)",
    },
  },
  {
    state: "ME",
    gracePeriod: 15,
    securityDeposit: "30 days (Me. Rev. Stat. tit. 14, § 6033).",
    vacate: {
      monthly: "30-days",
      yearly: "30-days",
    },
  },
  {
    state: "MD",
    gracePeriod: null,
    securityDeposit: "45 days (Md. Code Real Prop., § 8-203.1).",
    vacate: {
      monthly: "60-days; 30-days in the event of a breach of lease",
      yearly: "60-days",
    },
  },
  {
    state: "MA",
    gracePeriod: 30,
    securityDeposit: "30 days (Mass. Gen. Laws ch. 186, § 15B).",
    vacate: {
      monthly: "30-days (Massachusetts General Law Chapter 186 § 12)",
      yearly: "90-days (Massachusetts General Law Chapter 186 § 12)",
    },
  },
  {
    state: "MI",
    gracePeriod: null,
    securityDeposit: "30 days (Mich. Comp. Laws § 554.609).",
    vacate: {
      monthly: "30-days (Michigan Revised Statute § 554.134)",
      yearly: "1-year (Michigan Revised Statute § 554.134)",
    },
  },
  {
    state: "MN",
    gracePeriod: null,
    securityDeposit:
      "3 weeks after Tenant leaves and Landlord receives forwarding address; 5 days if Tenant must leave due to building condemnation (Minn. Stat. § 504B.178).",
    vacate: {
      monthly: "30-days, given prior to due date of last intended rent payment",
      yearly: "30-days, given prior to due date of last intended rent payment",
    },
  },
  {
    state: "MS",
    gracePeriod: null,
    securityDeposit: "45 days (Miss. Code §§ 89-8-21).",
    vacate: {
      monthly: "30-days (Mississippi Code § 89-8-19)",
      yearly: "30-days (Mississippi Code § 89-8-19)",
    },
  },
  {
    state: "MO",
    gracePeriod: null,
    securityDeposit: "30 days (Mo. Rev. Stat § 535.300).",
    vacate: {
      monthly: "1-month (Missouri Revised Statute § 441.050, 441.060)",
      yearly: "60-days (Missouri Revised Statute § 441.050, 441.060)",
    },
  },
  {
    state: "MT",
    gracePeriod: null,
    securityDeposit:
      "30 days; 10 days if no deductions. Landlord need not return the deposit if the tenancy was terminated pursuant to Mont. Code §§ 70-24-427 or 70-33-427 (eviction with a claim for rent and damages), and a Landlord has a pending claim in court for actual damages (Mont. Code §§ 70-24-427, 70-25-202, 70-33-427).",
    vacate: {
      monthly: "30-days (Montana Code § 70-24-441)",
      yearly: "N/A - defaults to month-to-month at end of lease term",
    },
  },
  {
    state: "NE",
    gracePeriod: null,
    securityDeposit: "14 days (Neb. Rev. Stat. § 76-1416)",
    vacate: {
      monthly: "1-month (Nebraska Revised Statute § 76-1437)",
      yearly: "N/A - defaults to month-to-month at end of lease term",
    },
  },
  {
    state: "NV",
    gracePeriod: null,
    securityDeposit: "30 days (Nev. Rev. Stat. § 118A.242)",
    vacate: {
      monthly:
        "30-days unless otherwise perscribed by Nevada Revised Statutes 118A.340, 118A.345",
      yearly:
        "N/A - unless otherwise perscribed by Nevada Revised Statutes 118A.340, 118A.345s",
    },
  },
  {
    state: "NH",
    gracePeriod: null,
    securityDeposit:
      "30 days; for shared facilities, if the deposit is more than 30 days' rent, Landlord must provide written agreement acknowledging receipt and specifying when deposit will be returned. If no written agreement, 20 days after Tenant vacates (N.H. Rev. Stat. §§ 540-A:7, 540-B-10).",
    vacate: {
      monthly: "30-days (New Hampshire Revised Statute 540:11)",
      yearly: "N/A - defaults to month-to-month at end of lease term",
    },
  },
  {
    state: "NJ",
    gracePeriod: 5,
    securityDeposit:
      "30 days; within 5 days if Tenant has to move out due to fire, flood, condemnation, or evacuation (N.J. Stat. § 46:8-21.1).",
    vacate: {
      monthly:
        "30-days unless otherwise perscribed by New Jersey Statute 46:8-9.1",
      yearly:
        "N/A - unless otherwise perscribed by New Jersey Statute 46:8-9.1",
    },
  },
  {
    state: "NM",
    gracePeriod: null,
    securityDeposit: "30 days (N.M. Stat. § 47-8-18).",
    vacate: {
      monthly: "30-days",
      yearly: "N/A - defaults to month-to-month at end of lease term",
    },
  },
  {
    state: "NY",
    gracePeriod: 5,
    securityDeposit: "14 days (N.Y. Gen. Oblig. Law § 7-108).",
    vacate: {
      monthly:
        "30-days if occupied less than one year, 60-days if occupied over one year but less thantwo years, otherwise 90-days",
      yearly:
        "30-days if occupied less than one year, 60-days if occupied over one year but less thantwo years, otherwise 90-days",
    },
  },
  {
    state: "NC",
    gracePeriod: 5,
    securityDeposit:
      "30 days; if Landlord's claim against the deposit can't be finalized within that time, Landlord can send an interim accounting and a final accounting within 60 days of the tenancy's end (N.C. Gen Stat. § 42-52).",
    vacate: {
      monthly: "7-days (North Carolina General Statute § 42-14)",
      yearly: "1-month (North Carolina General Statute § 42-14)",
    },
  },
  {
    state: "ND",
    gracePeriod: null,
    securityDeposit: "30 days (N.D. Cent. Code § 47-16-07.1).",
    vacate: {
      monthly: "1-month (North Dakota Century Code § 47-16-15)",
      yearly: "1-month (North Dakota Century Code § 47-16-15)",
    },
  },
  {
    state: "OH",
    gracePeriod: null,
    securityDeposit: "30 days (Ohio Rev. Code § 5321.16).",
    vacate: {
      monthly: "30-days (Revised Code § 5321.17)",
      yearly: "N/A - defaults to month-to-month at end of lease term",
    },
  },
  {
    state: "OK",
    gracePeriod: null,
    securityDeposit: "45 days (Okla. Stat. tit. 41, § 115).",
    vacate: {
      monthly: "30-days (Oklahoma Statute § 41-111)",
      yearly: "N/A - defaults to month-to-month at end of lease term",
    },
  },
  {
    state: "OR",
    gracePeriod: 5,
    securityDeposit: "31 days (Or. Rev. Stat. § 90.300).",
    vacate: {
      monthly: "30-days (Oregon Revised Statute § 91.070)",
      yearly: "N/A - defaults to month-to-month at end of lease term",
    },
  },
  {
    state: "PA",
    gracePeriod: null,
    securityDeposit: "30 days (68 Pa. Stat. § 250.512).",
    vacate: {
      monthly: "15-days (Pennsylvania Landlord Tenant Act)",
      yearly: "30-days (Pennsylvania Landlord Tenant Act)",
    },
  },
  {
    state: "RI",
    gracePeriod: null,
    securityDeposit: "20 days (R.I. Gen. Laws § 34-18-19).",
    vacate: {
      monthly: "",
      yearly: "",
    },
  },
  {
    state: "SC",
    gracePeriod: null,
    securityDeposit: "30 days (S.C. Code § 27-40-410).",
    vacate: {
      monthly: "30-days (Rhode Island Landlord and Tenant Act § 34-18-37)",
      yearly: "90-days (Rhode Island Landlord and Tenant Act § 34-18-37)",
    },
  },
  {
    state: "SD",
    gracePeriod: null,
    securityDeposit:
      "2 weeks, and Landlord must supply reasons if withholding any portion; 45 days for a written, itemized accounting if Tenant requests one (S.D. Codified Laws § 43-32-24).",
    vacate: {
      monthly: "30-days (South Dakota Codified Law § 43-8-8)",
      yearly: "30-days (South Dakota Codified Law § 43-8-8)",
    },
  },
  {
    state: "TN",
    gracePeriod: null,
    securityDeposit:
      "no statutory deadline for returning security deposit, but Landlord must send notification to the Tenant's last known address of the amount of any refund due. If the Landlord doesn't receive a response from the Tenant within 60 days of sending the notification, the Landlord may retain the deposit (Tenn. Code § 66-28-301).",
    vacate: {
      monthly: "30-days (Tennessee’s Landlord Tenant Act § 66-28-512)",
      yearly: "N/A - defaults to month-to-month at end of lease term",
    },
  },
  {
    state: "TX",
    gracePeriod: 3,
    securityDeposit:
      "30 days. Landlord doesn't need to refund deposit until the Tenant gives the Landlord a forwarding address. (Tex. Prop. Code § 92.103).",
    vacate: {
      monthly: "30-days",
      yearly: "30-days",
    },
  },
  {
    state: "UT",
    gracePeriod: null,
    securityDeposit: "30 days (Utah Code § 57-17-3)",
    vacate: {
      monthly: "15-days prior to end of current month",
      yearly: "15-days prior to end of lease term",
    },
  },
  {
    state: "VT",
    gracePeriod: 5,
    securityDeposit:
      "14 days; 60 days if the rental is seasonal and not intended as the Tenant's primary residence (Vt. Stat. tit. 9, § 4461).",
    vacate: {
      monthly: "30-days",
      yearly: "30-days (Vermont Statute Title 9 Chapter 37 § 4467)",
    },
  },
  {
    state: "VA",
    gracePeriod: null,
    securityDeposit:
      "45 days after termination or the date Tenant vacates, whichever occurs last; 30 days to itemize any deductions to be made during the course of the tenancy (60 days if the deductions exceed the amount of the security deposit). Lease can provide for expedited processing at the end of the tenancy and specify an administrative fee for such processing, which will apply only if Tenant requests it with a separate written document. Landlord must give Tenant written notice of Tenant's right to be present at a final inspection. If Tenant finds the unit uninhabitable within 7 days of move-in, Tenant may terminate and vacate; Landlord must return the deposit within 15 days of receipt of the termination notice or Tenant's vacating the unit, whichever is later (Va. Code § 55.1-1226).",
    vacate: {
      monthly:
        "30-days (Virginia Residential Landlord and Tenant Act § 55.1-1235)",
      yearly: "N/A - defaults to month-to-month at end of leasee term",
    },
  },
  {
    state: "WA",
    gracePeriod: 5,
    securityDeposit:
      "30 days, but if Landlord retains the deposit for reasons unrelated to damages (such as for rent or other unpaid charges), Landlord need not comply with checklist and documentation requirements (Wash. Rev. Code § 59.18.280).",
    vacate: {
      monthly: "20-days (Revised Code of Washington 59.18.200)",
      yearly: "20-days (Revised Code of Washington 59.18.200)",
    },
  },
  {
    state: "WV",
    gracePeriod: null,
    securityDeposit:
      "60 days from the date the tenancy has terminated (W.Va. Code § 37-6A-1).",
    vacate: {
      monthly: "30-days (West Virginia Code § 37-6-5)",
      yearly: "90-days (West Virginia Code § 37-6-5)",
    },
  },
  {
    state: "WI",
    gracePeriod: null,
    securityDeposit:
      "21 days (Wis. Stat. § 704.28; Wis. Admin. Code § 134.06).",
    vacate: {
      monthly: "28-days (Wisconsin Statute § 704.19)",
      yearly: "28-days (Wisconsin Statute § 704.19)",
    },
  },
  {
    state: "WY",
    gracePeriod: null,
    securityDeposit:
      "30 days when applying security deposit to unpaid rent (or within 15 days of receiving Tenant's forwarding address, whichever is later); additional 30 days allowed for deductions due to damage (Wyo. Stat. § 1-21-1208).",
    vacate: {
      monthly: "30-days",
      yearly: "30-days",
    },
  },
];
